import React, { useEffect, useState } from "react";
import "./smsForm.css";
import {
    getSmsConfigs,
    createSmsConfig,
    updateSmsConfig,
    deleteSmsConfig,
} from "../services/smsConfigApi";

const initialForm = {
    apiUrl: "",
    authKey: "",
    senderId: "",
    route: "",
    active: false,
};

function SmsConfig() {
    const [form, setForm] = useState(initialForm);
    const [data, setData] = useState([]);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await getSmsConfigs();
            setData(res);
        } catch (err) {
            console.error("Fetch error", err);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSave = async () => {
        try {
            if (editId) {
                await updateSmsConfig(editId, form);
            } else {
                await createSmsConfig(form);
            }
            fetchData();
            handleClear();
        } catch (err) {
            console.error("Save error", err);
        }
    };

    const handleEdit = (item) => {
        setForm(item);
        setEditId(item.id);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Delete this config?")) {
            try {
                await deleteSmsConfig(id);
                fetchData();
            } catch (err) {
                console.error("Delete error", err);
            }
        }
    };

    const handleClear = () => {
        setForm(initialForm);
        setEditId(null);
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>⚙️ SMS Config</h2>
                <p>Manage SMS API endpoints and routing settings</p>
            </div>

            {/* FORM CARD */}
            <div className="card">
                <div className="form-grid">
                    <div className="form-group">
                        <label>API URL</label>
                        <input name="apiUrl" value={form.apiUrl} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Auth Key</label>
                        <input name="authKey" value={form.authKey} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Sender ID</label>
                        <input name="senderId" value={form.senderId} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                        <label>Route</label>
                        <input name="route" value={form.route} onChange={handleChange} />
                    </div>
                </div>

                <div className="checkbox">
                    <input
                        type="checkbox"
                        name="active"
                        checked={form.active}
                        onChange={handleChange}
                    />
                    <label>Active</label>
                </div>

                <div className="button-group">
                    <button className="button save" onClick={handleSave}>
                        {editId ? "Update" : "Add"}
                    </button>
                    <button className="button clear" onClick={handleClear}>
                        Clear
                    </button>
                </div>
            </div>

            {/* TABLE CARD */}
            <div className="card">
                <h3>📋 Config List</h3>

                <table className="table">
                    <thead>
                        <tr>
                            <th>API URL</th>
                            <th>Auth Key</th>
                            <th>Sender ID</th>
                            <th>Route</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((item) => (
                            <tr key={item.id}>
                                <td className="url-cell">{item.apiUrl}</td>
                                <td>{item.authKey}</td>
                                <td>{item.senderId}</td>
                                <td>{item.route}</td>
                                <td>
                                    <span className={item.active ? "badge active" : "badge inactive"}>
                                        {item.active ? "Active" : "Inactive"}
                                    </span>
                                </td>
                                <td>
                                    <div className="action-buttons">
                                        <button onClick={() => handleEdit(item)}>Edit</button>
                                        <button onClick={() => handleDelete(item.id)}>Delete</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default SmsConfig;